import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
})
export class ListViewComponent implements OnInit {

  @Input() title:string;
  @Input() icon:string;

  constructor() { }

  ngOnInit() {
  }

}
